export default __webpack_public_path__ + "static/media/icon-settings.569296c6.svg";